import { Injectable } from '@angular/core';
import { LoaderService } from '../../core/header-menu/loader/loader.service';
import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';

@Injectable()
export class LoaderInterceptorService implements HttpInterceptor {

  constructor(
    private loaderService: LoaderService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let lastResponse: HttpEvent<any>;
    let error: HttpErrorResponse;
    this.loaderService.add();

    return next.handle(request)
      .pipe(
        tap(event => {
          lastResponse = event;
          if (event.type === HttpEventType.Response) {
            this.loaderService.remove();
          }
        }),
        catchError(err => {
          error = err;
          this.loaderService.remove();
          return throwError(err);
        }),
        finalize(() => {
          if (lastResponse.type === HttpEventType.Sent && !error) {
            this.loaderService.remove();
          }
        }),
      );
  }
}
